var React = require('react');

function IconComments (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 22c-.6 0-1-.4-1-1v-3H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6.1l-3.7 3.7c-.2.2-.4.3-.7.3H9zm1-6v3.1l3.1-3.1H20V4H4v12h6zm6.3-10l-1.4 3H17v4h-4V8.8L14.3 6h2zm-6 0L8.9 9H11v4H7V8.8L8.3 6h2z"}));
}

IconComments.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconComments;

IconComments.default = IconComments;
